export default {
  data() {
    return {
      disableButtons: false,
      spinningButton: {
        buttonType: null,
        requestId: null
      }
    };
  },
  methods: {
    isSpinning(buttonType, id) {
      return (
        this.spinningButton.buttonType === buttonType &&
        this.spinningButton.requestId === id
      );
    },
    toggleButtonsState(buttonType, requestId) {
      this.disableButtons = !this.disableButtons;
      if (this.spinningButton.buttonType === null) {
        this.spinningButton = {
          buttonType,
          requestId
        };
      } else {
        this.spinningButton = {
          buttonType: null,
          requestId: null
        };
      }
    }
  }
};
